export default __webpack_public_path__ + "static/media/news_inclusivity.ca36a0cd.jpg";